module.exports = __webpack_public_path__ + "static/media/21poolroom-logo.60fb74af.png";